module.exports = __webpack_public_path__ + "static/media/up-arrow.96af5d6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/up-arrow.svg
// module id = 836
// module chunks = 0